/**
 * Helper function to calculate overflow index
 * @param parentContainerWidth Width of parent container in pixels
 * @param widthArray Width array calculated in getWidthArray function
 * @param dropdownWidth Width of overflow dropdown menu
 * @returns overflow index (exclusive)
 */
export function getOverflowIndex(parentContainerWidth, widthArray, dropdownWidth) {
    if (dropdownWidth === void 0) { dropdownWidth = 0; }
    if (!widthArray || !parentContainerWidth) {
        return undefined;
    }
    else {
        for (var i = widthArray.length - 1; i >= 0; i--) {
            var currentWidth = i < widthArray.length - 1
                ? widthArray[i] + dropdownWidth
                : widthArray[i];
            if (currentWidth <= parentContainerWidth) {
                return i + 1; //Add one since slice function is exclusive
            }
        }
        return 0;
    }
}
//# sourceMappingURL=getOverflowIndex.js.map